import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import './styles/App.css';
import MainPage from './pages/MainPage/MainPage';
import PainExtractor from './pages/PainExtractor/PainExtractor';
import LeadFinder from './pages/LeadFinder/LeadFinder';
import PostValidator from './pages/PostValidator/PostValidator';
import PostEnhancer from './pages/PostEnhancer/PostEnhancer';
import PostTimer from './pages/PostTimer/PostTimer';
import ContactUs from './pages/ContactUs/ContactUs';
import SignIn from './pages/SignIn/SignIn';
import SignUp from './pages/SignUp/SignUp';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import ProtectedRoute from './components/ProtectedRoute';
import BlogPage from './pages/Blog/BlogPage';
import BlogPostPage from './pages/BlogPost/BlogPostPage';
// import BlogAdmin from './pages/BlogAdmin/BlogAdmin';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/lead-finder" element={<ProtectedRoute><LeadFinder /></ProtectedRoute>} />
        <Route path="/pain-extractor" element={<ProtectedRoute><PainExtractor /></ProtectedRoute>} />
        <Route path="/post-validator" element={<ProtectedRoute><PostValidator /></ProtectedRoute>} />
        <Route path="/post-enhancer" element={<ProtectedRoute><PostEnhancer /></ProtectedRoute>} />
        <Route path="/post-timer" element={<ProtectedRoute><PostTimer /></ProtectedRoute>} />
        {/* <Route path="/admin/blog" element={<ProtectedRoute><BlogAdmin /></ProtectedRoute>} /> */}
      </Routes>
    </Layout>
  );
}

export default App;